import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	MJ: {
		'id': 'typePlants.mj',
		'defaultMessage': 'MJ'
	},
	Avocado: {
		'id': 'typePlants.avocado',
		'defaultMessage': 'Avocado'
	},
	Lime: {
		'id': 'typePlants.lime',
		'defaultMessage': 'Lime'
	},
	Feijoa: {
		'id': 'typePlants.feijoa',
		'defaultMessage': 'Feijoa'
	},
	Garnet: {
		'id': 'typePlants.garnet',
		'defaultMessage': 'Garnet'
	},
	Pepino: {
		'id': 'typePlants.pepino',
		'defaultMessage': 'Pepino'
	},
	DateFruit: {
		'id': 'typePlants.dateFruit',
		'defaultMessage': 'Date fruit'
	},
	Kiwi: {
		'id': 'typePlants.kiwi',
		'defaultMessage': 'Kiwi'
	},
	Strawberry: {
		'id': 'typePlants.strawberry',
		'defaultMessage': 'Strawberry'
	},
	Apple: {
		'id': 'typePlants.apple',
		'defaultMessage': 'Apple'
	}
});


// WEBPACK FOOTER //
// ./src/components/AnswerTypePlants/messages.js